import { addDays, format, subDays, formatDate as fnsFormatDate } from "date-fns";
import { DEFAULT_30_DAY_EXPIRATION } from "../app.constants";

export type DateFormat = "yyyy/MM/dd" | "yyyy-MM-dd" | "yyyyMMdd";

export function getFormatedExpirationDate(dateFormat: DateFormat = "yyyy/MM/dd") {
  const expirationDate = getExpirationDate();
  return format(expirationDate, dateFormat);
}

export function getExpirationDate() {
  const date = new Date();
  return addDays(date, DEFAULT_30_DAY_EXPIRATION);
}

export function removeDays(date: Date, days: number) {
  return subDays(date, days);
}

export function formatDate(date: Date, format: DateFormat) {
  return fnsFormatDate(date, format);
}

/** How ViSOL stores an image date and how the EXIF readers return it: local wall-clock time, no zone. */
const IMAGE_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";

/**
 * The date to store for an image whose file carries no EXIF date (Merry captures, screenshots): the last modification
 * time of the file as local wall-clock time, formatted like the EXIF dates of the other scopes. Null when the file has
 * no usable modification time.
 */
export function fileLastModifiedLocal(file: Pick<File, "lastModified"> | null | undefined): string | null {
  return toLocalDateTime(file?.lastModified);
}

/** Formats an instant (epoch milliseconds, Date, or a parsable string) as local wall-clock time without zone; null when unusable. */
export function toLocalDateTime(instant: number | string | Date | null | undefined): string | null {
  if (instant === null || instant === undefined || instant === "") {
    return null;
  }
  const date = instant instanceof Date ? instant : new Date(instant);
  return Number.isFinite(date.getTime()) && date.getTime() > 0 ? format(date, IMAGE_DATE_FORMAT) : null;
}
